import gql from 'graphql-tag';

const getTappyMaintenanceStatusQuery = gql`
  query maintenanceFeatureFlagQuery {
    tappyMaintenanceFlagStatus {
      active
    }
  }
`;

export default getTappyMaintenanceStatusQuery;
